import axios from '../../config/axios.js'

const STATE = {

    email: null,
    products: [],
    prod_id: null,
    price_unit: null,
    method: null,
    drawer: false,

    mp_id: 1,

    // nodes: [],
    // edges: [],
    // width: 0,
    // height: 0,
    // attr_node_size: 'in_degree',
    // tree: null,

}

const GETTERS = {

    email: state => state.email,
    products: state => state.products,
    prod_id: state => state.prod_id,
    price_unit: state => state.price_unit,
    method: state => state.method,
    drawer: state => state.drawer,

    mp_id: state => state.mp_id,

    // nodes: state => state.nodes,
    // edges: state => state.edges,
    // width: state => state.width,
    // height: state => state.height,
    // tree: state => state.tree,
    // attr_node_size: state => state.attr_node_size,

}

const MUTATIONS = {

    setEmail(state, email) {
        state.email = email
    },

    resetEmail(state) {
        state.email = null
    },

    getProducts(state, products) {
        state.products = products
    },

    setProdId(state, prod_id) {
        state.prod_id = prod_id
    },

    resetProdId(state) {
        state.prod_id = null
    },

    setPriceUnit(state, price_unit) {
        state.price_unit = price_unit
    },

    setMethod(state, method) {
        state.method = method
    },

    setDrawer(state, drawer) {
        state.drawer = drawer
    },

    // getRandomTree(state, tree) {
    //     state.nodes = tree.nodes
    //     state.edges = tree.edges
    //     state.width = tree.frame.width
    //     state.height = tree.frame.height
    //     state.tree = tree
    // }

}

const ACTIONS = {
    async getProducts({ commit }) {
        await axios.ACCESS.get('/api/products')
            .then(res => {
                // console.log('welcome/getProducts', res)
                if (res.data.result) {
                    commit('getProducts', res.data.products)
                } else {
                    throw new Error(res.data)
                }
            })
    },

    // async getRandomTree({ commit }) {
    //     await axios.ACCESS.post('/api/tree')
    //         .then(res => {
    //             console.log('welcome/getRandomTree', res)
    //             commit('getRandomTree', res.data)
    //         })
    // },
}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/welcome.js